import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "rgb(var(--color-konnect-platform-brand))",
      "fill-rule": "evenodd",
      d: "M9.924 2.4 5.76 9.6h12.48L12 20.4 5.76 9.6l-4.248 7.368 2.16 3.432H21.24l1.608-2.808L14.088 2.4H9.912z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }